<!-- PANE 3 -->
<div class="pane3" #paneContent>
  <!-- Pane 3 header toolbar -->
  <mat-toolbar class="pane-header">
    <!-- Mobile Menu Toggle Button - Only visible in mobile view -->
    <button *ngIf="isMobileView"
            mat-icon-button
            class="mobile-menu-button"
            (click)="onToggleMobileNav()"
            matTooltip="Toggle Navigation">
      <mat-icon>menu</mat-icon>
    </button>

    <!-- Display Mode Dropdown (Desktop) -->
    <div *ngIf="!isMobileView" class="header-form-group">
      <!-- Display Mode Dropdown -->
      <mat-form-field appearance="fill" class="modern-select">
        <mat-label>Display Mode</mat-label>
        <mat-select [(value)]="displayMode" (selectionChange)="onDisplayModeChange()" panelClass="modern-select-panel">
          <mat-option *ngFor="let option of displayModes" [value]="option.value">
            {{option.label}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Language Selection Dropdown -->
      <mat-form-field appearance="fill" class="modern-select">
        <mat-label>Language Selection</mat-label>
        <mat-select #langSelect [(value)]="selectedLanguage" (selectionChange)="onLanguageChange(); langSelect.close()" panelClass="modern-select-panel">
          <mat-option *ngFor="let option of languageOptions" [value]="option.value">
            {{option.label}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Image Size Selector -->
      <mat-button-toggle-group [(ngModel)]="imageSize" class="image-size-toggle" aria-label="Image Size">
        <mat-button-toggle *ngFor="let opt of imageSizeOptions" [value]="opt.value">{{opt.label}}</mat-button-toggle>
      </mat-button-toggle-group>

      <!-- Bilingual Layout Toggle (only visible when bilingual is selected) -->
      <mat-slide-toggle
        *ngIf="selectedLanguage === 'bilingual'"
        [checked]="bilingualLayout === 'sideBySide'"
        (change)="bilingualLayout = $event.checked ? 'sideBySide' : 'stacked'"
        color="primary"
        class="header-toggle">
        Side-by-Side
      </mat-slide-toggle>

      <!-- Show Correct Answer Toggle -->
      <mat-slide-toggle
        [(ngModel)]="showCorrectAnswer"
        color="primary"
        class="header-toggle">
        Show Answer
      </mat-slide-toggle>

      <!-- Options Layout Toggle -->
      <mat-slide-toggle
        [(ngModel)]="optionsLayoutVertical"
        color="primary"
        class="header-toggle">
        Vertical Options
      </mat-slide-toggle>
    </div>

    <!-- Mobile icons for dropdowns - only visible in mobile view -->
    <div *ngIf="isMobileView" class="mobile-icons-container">
      <!-- Display Mode Icon -->
      <button mat-flat-button
              color="primary"
              [matMenuTriggerFor]="displayMode_menu"
              matTooltip="Display Mode"
              class="mobile-icon-button">
        <mat-icon>{{ getDisplayModeIcon() }}</mat-icon>
        <span class="icon-label">DISPLAY</span>
      </button>

      <!-- Language Selection Icon -->
      <button mat-flat-button
              color="primary"
              [matMenuTriggerFor]="language_menu"
              matTooltip="Language Selection"
              class="mobile-icon-button">
        <mat-icon>{{ getLanguageIcon() }}</mat-icon>
        <span class="icon-label">Lang</span>
      </button>

      <!-- Image Size Icon -->
      <button mat-flat-button
              color="primary"
              [matMenuTriggerFor]="imageSize_menu"
              matTooltip="Image Size"
              class="mobile-icon-button">
        <mat-icon>photo_size_select_large</mat-icon>
        <span class="icon-label">{{ imageSize }}</span>
      </button>

      <!-- Bilingual Layout Toggle (Mobile) -->
      <button mat-flat-button
              *ngIf="selectedLanguage === 'bilingual'"
              [color]="bilingualLayout === 'sideBySide' ? 'accent' : 'primary'"
              (click)="bilingualLayout = bilingualLayout === 'sideBySide' ? 'stacked' : 'sideBySide'"
              matTooltip="Toggle Bilingual Layout"
              class="mobile-icon-button">
        <mat-icon>{{ bilingualLayout === 'sideBySide' ? 'view_column' : 'view_agenda' }}</mat-icon>
        <span class="icon-label">{{ bilingualLayout === 'sideBySide' ? 'SIDE' : 'STACK' }}</span>
      </button>

      <!-- Show Answer Toggle (Mobile) -->
      <button mat-flat-button
              [color]="showCorrectAnswer ? 'accent' : 'primary'"
              (click)="showCorrectAnswer = !showCorrectAnswer"
              matTooltip="Show Correct Answer"
              class="mobile-icon-button">
        <mat-icon>{{ showCorrectAnswer ? 'check_circle' : 'check_circle_outline' }}</mat-icon>
        <span class="icon-label">ANS</span>
      </button>

      <!-- Vertical Options Toggle (Mobile) -->
      <button mat-flat-button
              [color]="optionsLayoutVertical ? 'accent' : 'primary'"
              (click)="optionsLayoutVertical = !optionsLayoutVertical"
              matTooltip="Toggle Options Layout"
              class="mobile-icon-button">
        <mat-icon>{{ optionsLayoutVertical ? 'view_agenda' : 'view_column' }}</mat-icon>
        <span class="icon-label">LAYOUT</span>
      </button>

      <!-- Show Details as button in mobile view -->
      <button mat-flat-button
              *ngIf="!isMobileView"
              color="primary"
              (click)="toggleShowDetails()"
              matTooltip="Toggle details panel"
              class="mobile-icon-button">
        <mat-icon>{{ showDetails ? 'visibility' : 'visibility_off' }}</mat-icon>
        <span class="icon-label">Details</span>
      </button>

      <!-- Show Details as button in mobile view -->
      <button mat-flat-button
              color="primary"
              (click)="toggleShowDetails()"
              matTooltip="Toggle details panel"
              class="mobile-icon-button">
        <mat-icon>{{ showDetails ? 'visibility' : 'visibility_off' }}</mat-icon>
        <span class="icon-label">Details</span>
      </button>
    </div>

    <span class="spacer"></span>

    <!-- Show Details Checkbox - Only visible on desktop when details area is closed -->
    <mat-checkbox *ngIf="!isMobileView && !showDetails"
                  [(ngModel)]="showDetails"
                  color="primary"
                  (change)="onShowDetailsChange()"
                  class="show-details-checkbox">
      Show Details
    </mat-checkbox>



    <!-- View Mode Menu for Display and Language selectors-->
    <mat-menu #displayMode_menu="matMenu">
      <button mat-menu-item *ngFor="let option of displayModes" (click)="displayMode = option.value; onDisplayModeChange()">
        <mat-icon>{{ getDisplayModeIcon() }}</mat-icon>
        <span>{{ option.label }}</span>
      </button>
    </mat-menu>

    <mat-menu #language_menu="matMenu">
      <button mat-menu-item *ngFor="let option of languageOptions" (click)="selectedLanguage = option.value; onLanguageChange()">
        <mat-icon>{{ getLanguageIcon() }}</mat-icon>
        <span>{{ option.label }}</span>
      </button>
    </mat-menu>

    <mat-menu #imageSize_menu="matMenu">
      <button mat-menu-item *ngFor="let opt of imageSizeOptions" (click)="imageSize = opt.value">
        <span>{{ opt.label }}</span>
      </button>
    </mat-menu>
  </mat-toolbar>

  <!-- Sub-header with navigation path + "Expand All" button -->
  <div class="pane-content" [ngClass]="{'single-view-mode': displayMode === 'single'}" (scroll)="onPaneScroll($event)">
    <mat-toolbar color="transparent" class="sub-header with-button">
      <!-- Updated Desktop Navigation Path from NavigationPathService - Only visible in desktop view -->
      <div *ngIf="!isMobileView" class="shared-navigation-path-container navigation-path">
        <!-- Show navigation path based on selections from service -->
        <ng-container *ngIf="navigationPathItems.length > 0">
          <!-- Single line: Show only first and last items -->
          <div class="path-line compact-context">
            <!-- Root level (first item) -->
            <div class="path-item root" *ngIf="navigationPathItems.length > 0">
              {{ formatNodeName(navigationPathItems[0].name, navigationPathItems[0].hindiName) }}
            </div>

            <!-- Truncation element if we have more than 2 levels -->
            <div class="path-separator" *ngIf="navigationPathItems.length > 1">→</div>

            <div class="path-truncation" *ngIf="navigationPathItems.length > 2" (click)="$event.stopPropagation()" [matMenuTriggerFor]="truncatedMenu">
              <span class="truncation-indicator">...</span>
            </div>

            <!-- Show truncated menu with all intermediate items -->
            <mat-menu #truncatedMenu="matMenu" class="truncated-levels-menu">
              <div class="truncated-menu-header">Intermediate Levels</div>
              <button mat-menu-item *ngFor="let item of navigationPathItems.slice(1, navigationPathItems.length - 1); let i = index" (click)="$event.stopPropagation()">
                {{ i + 2 }}. {{ formatNodeName(item.name, item.hindiName) }}
                <div class="path-separator" *ngIf="i < navigationPathItems.slice(1, navigationPathItems.length - 1).length - 1">↓</div>
              </button>
            </mat-menu>


            <!-- Add separator before current/last item -->
            <div class="path-separator" *ngIf="navigationPathItems.length > 2">→</div>

            <!-- Current/Last item -->
            <div class="path-item current" *ngIf="navigationPathItems.length > 1">
              {{ formatNodeName(navigationPathItems[navigationPathItems.length - 1].name, navigationPathItems[navigationPathItems.length - 1].hindiName) }}
            </div>
          </div>
        </ng-container>

        <!-- No selection message -->
        <div *ngIf="navigationPathItems.length === 0">
          Select a path to view questions
        </div>
      </div>

      <!-- Updated Mobile Navigation Path from NavigationPathService - Only visible in mobile view -->
      <div *ngIf="isMobileView" class="shared-navigation-path-container mobile-navigation-path">
        <!-- Show navigation path whenever we have items -->
        <ng-container *ngIf="navigationPathItems.length > 0">
          <!-- Clickable Navigation Path Icon -->
          <div class="mobile-nav-collapsed" (click)="toggleNavPathExpanded()">
            <div class="current-location">
              <mat-icon>explore</mat-icon>
              <span>PATH</span>
              <mat-icon>{{ isNavPathExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
            </div>
          </div>

          <!-- Expanded View -->
          <div *ngIf="isNavPathExpanded" class="mobile-nav-expanded">
            <div class="mobile-nav-header">
              <span>Current Path</span>
              <button mat-icon-button (click)="toggleNavPathExpanded()">
                <mat-icon>expand_less</mat-icon>
              </button>
            </div>

            <!-- Display path items based on their type -->
            <ng-container *ngFor="let item of navigationPathItems">
              <div class="mobile-nav-item">
                <span class="nav-label">{{ item.type | titlecase }}</span>
                <span class="nav-value">{{ formatNodeName(item.name, item.hindiName) }}</span>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <!-- No selection message for mobile -->
        <ng-container *ngIf="navigationPathItems.length === 0">
          <div class="mobile-nav-collapsed">
            <div class="current-location">
              <mat-icon>explore</mat-icon>
              <span>No path selected</span>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Expand All / Collapse All Button -->
      <button mat-stroked-button
              color="primary"
              class="expand-all-button"
              (click)="toggleAllCards()"
              *ngIf="displayMode !== 'single' && allCards.length > 0">
        <mat-icon>{{ allExpanded ? 'unfold_less' : 'unfold_more' }}</mat-icon>
        {{ allExpanded ? 'Collapse All' : 'Expand All' }}
      </button>
    </mat-toolbar>
    <mat-divider></mat-divider>

    <!-- CARD LIST OR SINGLE CARD -->
    <!-- For "single" mode, we might present a special template that ensures we have
         top portion for the image (auto-zoom) and bottom portion for text. -->
    <ng-container [ngSwitch]="displayMode">

      <!-- 1) ALL AT ONCE, 2) LAZY LOAD, or 3) 10 PER PAGE -->
      <ng-container *ngSwitchCase="'allAtOnce'">
        <div *ngIf="isLoadingQuestions" class="loading-indicator">
          <mat-progress-spinner diameter="36" mode="indeterminate" color="primary"></mat-progress-spinner>
          <span>Loading questions...</span>
        </div>
        <!-- Only show error if not loading -->
        <div *ngIf="hasQuestionsError && !isLoadingQuestions" class="error-message">
          <mat-icon>error</mat-icon> {{ questionsErrorMessage }}
        </div>
        <ng-container *ngIf="!isLoadingQuestions && !hasQuestionsError">
          <ng-container *ngFor="let card of displayedCards">
            <!-- Bilingual view (2x2 layout) -->
            <mat-card *ngIf="selectedLanguage === 'bilingual'"
                      class="ias-card bilingual-card"
                      [ngClass]="{'collapsed': card.collapsed}"
                      (click)="selectCard(card)">
              <mat-card-header class="card-header">
                <button mat-icon-button (click)="toggleCard(card); $event.stopPropagation()">
                  <mat-icon>{{ card.collapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
                </button>
              </mat-card-header>
              <mat-card-content>
                <!-- English content (top row) -->
                <div class="bilingual-row">
                  <!-- English Question Image -->
                  <div class="bilingual-cell" *ngIf="selectedContentType !== 'textOnly'">
                    <div class="image-container">
                      <img [src]="card.imageUrl" alt="English Question Image" class="centered-image">
                    </div>
                  </div>

                  <!-- English Question Text -->
                  <div class="bilingual-cell" *ngIf="selectedContentType !== 'imageOnly'">
                    <div [ngClass]="{'hidden-content': card.collapsed}" class="question-text-container">
                      <p>{{ card.questionText }}</p>
                    </div>
                  </div>
                </div>
                <!-- OCR Question Figure -->
                <div class="question-figure-container" *ngIf="card.questionFigureUrl">
                  <img [src]="card.questionFigureUrl" [alt]="card.questionFigureCaption || 'Question Figure'" class="question-figure-img">
                  <p *ngIf="card.questionFigureCaption" class="figure-caption">{{ card.questionFigureCaption }}</p>
                </div>

                <!-- Hindi content (bottom row) -->
                <div class="bilingual-row">
                  <!-- Hindi Question Image -->
                  <div class="bilingual-cell" *ngIf="selectedContentType !== 'textOnly'">
                    <div class="image-container">
                      <img [src]="card.hindiQuestionImageUrl || card.hindiImageUrl" alt="Hindi Question Image" class="centered-image">
                    </div>
                  </div>

                  <!-- Hindi Question Text -->
                  <div class="bilingual-cell" *ngIf="selectedContentType !== 'imageOnly'">
                    <div [ngClass]="{'hidden-content': card.collapsed}" class="question-text-container">
                      <p>{{ card.hindiQuestionText }}</p>
                    </div>
                  </div>
                </div>

                <!-- Hindi Options Grid -->
                <div class="options-grid" [class.options-vertical]="optionsLayoutVertical" *ngIf="!card.collapsed && selectedContentType !== 'textOnly' && (card.hindiOptionAImageUrl || card.hindiOptionBImageUrl || card.hindiOptionCImageUrl || card.hindiOptionDImageUrl)">
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'A'}" *ngIf="card.hindiOptionAImageUrl">
                    <span class="option-label">(a)</span>
                    <img [src]="card.hindiOptionAImageUrl" alt="Option A Hindi" class="option-img">
                  </div>
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'B'}" *ngIf="card.hindiOptionBImageUrl">
                    <span class="option-label">(b)</span>
                    <img [src]="card.hindiOptionBImageUrl" alt="Option B Hindi" class="option-img">
                  </div>
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'C'}" *ngIf="card.hindiOptionCImageUrl">
                    <span class="option-label">(c)</span>
                    <img [src]="card.hindiOptionCImageUrl" alt="Option C Hindi" class="option-img">
                  </div>
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'D'}" *ngIf="card.hindiOptionDImageUrl">
                    <span class="option-label">(d)</span>
                    <img [src]="card.hindiOptionDImageUrl" alt="Option D Hindi" class="option-img">
                  </div>
                </div>
                <!-- OCR Text Options -->
                <div class="options-grid text-options-grid" [class.options-vertical]="optionsLayoutVertical"
                     *ngIf="!card.collapsed && card.optionAText">
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'A'}">
                    <span class="option-label">(a)</span><span class="option-text">{{ card.optionAText }}</span>
                  </div>
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'B'}" *ngIf="card.optionBText">
                    <span class="option-label">(b)</span><span class="option-text">{{ card.optionBText }}</span>
                  </div>
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'C'}" *ngIf="card.optionCText">
                    <span class="option-label">(c)</span><span class="option-text">{{ card.optionCText }}</span>
                  </div>
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'D'}" *ngIf="card.optionDText">
                    <span class="option-label">(d)</span><span class="option-text">{{ card.optionDText }}</span>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <!-- English Only view (1x2 layout) -->
            <mat-card *ngIf="selectedLanguage === 'englishOnly'"
                      class="ias-card"
                      [ngClass]="{'collapsed': card.collapsed}"
                      (click)="selectCard(card)">
              <mat-card-header class="card-header">
                <button mat-icon-button (click)="toggleCard(card); $event.stopPropagation()">
                  <mat-icon>{{ card.collapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
                </button>
              </mat-card-header>
              <mat-card-content>
                <div class="single-language-row">
                  <!-- English Question Image -->
                  <div class="single-language-cell" *ngIf="selectedContentType !== 'textOnly'">
                    <div class="image-container">
                      <img [src]="card.imageUrl" alt="English Question Image" class="centered-image">
                    </div>
                  </div>

                  <!-- English Question Text -->
                  <div class="single-language-cell" *ngIf="selectedContentType !== 'imageOnly'">
                    <div [ngClass]="{'hidden-content': card.collapsed}" class="question-text-container">
                      <p>{{ card.questionText }}</p>
                    </div>
                  </div>
                </div>

                <!-- OCR Question Figure -->
                <div class="question-figure-container" *ngIf="card.questionFigureUrl">
                  <img [src]="card.questionFigureUrl" [alt]="card.questionFigureCaption || 'Question Figure'" class="question-figure-img">
                  <p *ngIf="card.questionFigureCaption" class="figure-caption">{{ card.questionFigureCaption }}</p>
                </div>
                <!-- Options Grid -->
                <div class="options-grid" [class.options-vertical]="optionsLayoutVertical" *ngIf="!card.collapsed && selectedContentType !== 'textOnly' && (card.optionAImageUrl || card.optionBImageUrl || card.optionCImageUrl || card.optionDImageUrl)">
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'A'}" *ngIf="card.optionAImageUrl">
                    <span class="option-label">(a)</span>
                    <img [src]="card.optionAImageUrl" alt="Option A" class="option-img">
                  </div>
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'B'}" *ngIf="card.optionBImageUrl">
                    <span class="option-label">(b)</span>
                    <img [src]="card.optionBImageUrl" alt="Option B" class="option-img">
                  </div>
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'C'}" *ngIf="card.optionCImageUrl">
                    <span class="option-label">(c)</span>
                    <img [src]="card.optionCImageUrl" alt="Option C" class="option-img">
                  </div>
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'D'}" *ngIf="card.optionDImageUrl">
                    <span class="option-label">(d)</span>
                    <img [src]="card.optionDImageUrl" alt="Option D" class="option-img">
                  </div>
                </div>
                <!-- OCR Text Options -->
                <div class="options-grid text-options-grid" [class.options-vertical]="optionsLayoutVertical"
                     *ngIf="!card.collapsed && card.optionAText">
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'A'}">
                    <span class="option-label">(a)</span><span class="option-text">{{ card.optionAText }}</span>
                  </div>
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'B'}" *ngIf="card.optionBText">
                    <span class="option-label">(b)</span><span class="option-text">{{ card.optionBText }}</span>
                  </div>
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'C'}" *ngIf="card.optionCText">
                    <span class="option-label">(c)</span><span class="option-text">{{ card.optionCText }}</span>
                  </div>
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'D'}" *ngIf="card.optionDText">
                    <span class="option-label">(d)</span><span class="option-text">{{ card.optionDText }}</span>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <!-- Hindi Only view (1x2 layout) -->
            <mat-card *ngIf="selectedLanguage === 'hindiOnly'"
                      class="ias-card"
                      [ngClass]="{'collapsed': card.collapsed}"
                      (click)="selectCard(card)">
              <mat-card-header class="card-header">
                <button mat-icon-button (click)="toggleCard(card); $event.stopPropagation()">
                  <mat-icon>{{ card.collapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
                </button>
              </mat-card-header>
              <mat-card-content>
                <div class="single-language-row">
                  <!-- Hindi Question Image -->
                  <div class="single-language-cell" *ngIf="selectedContentType !== 'textOnly'">
                    <div class="image-container">
                      <img [src]="card.hindiQuestionImageUrl || card.hindiImageUrl" alt="Hindi Question Image" class="centered-image">
                    </div>
                  </div>

                  <!-- Hindi Question Text -->
                  <div class="single-language-cell" *ngIf="selectedContentType !== 'imageOnly'">
                    <div [ngClass]="{'hidden-content': card.collapsed}" class="question-text-container">
                      <p>{{ card.hindiQuestionText }}</p>
                    </div>
                  </div>
                </div>

                <!-- Hindi Options Grid -->
                <div class="options-grid" [class.options-vertical]="optionsLayoutVertical" *ngIf="!card.collapsed && selectedContentType !== 'textOnly' && (card.hindiOptionAImageUrl || card.hindiOptionBImageUrl || card.hindiOptionCImageUrl || card.hindiOptionDImageUrl)">
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'A'}" *ngIf="card.hindiOptionAImageUrl">
                    <span class="option-label">(a)</span>
                    <img [src]="card.hindiOptionAImageUrl" alt="Option A Hindi" class="option-img">
                  </div>
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'B'}" *ngIf="card.hindiOptionBImageUrl">
                    <span class="option-label">(b)</span>
                    <img [src]="card.hindiOptionBImageUrl" alt="Option B Hindi" class="option-img">
                  </div>
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'C'}" *ngIf="card.hindiOptionCImageUrl">
                    <span class="option-label">(c)</span>
                    <img [src]="card.hindiOptionCImageUrl" alt="Option C Hindi" class="option-img">
                  </div>
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'D'}" *ngIf="card.hindiOptionDImageUrl">
                    <span class="option-label">(d)</span>
                    <img [src]="card.hindiOptionDImageUrl" alt="Option D Hindi" class="option-img">
                  </div>
                </div>
                <!-- OCR Text Options -->
                <div class="options-grid text-options-grid" [class.options-vertical]="optionsLayoutVertical"
                     *ngIf="!card.collapsed && card.optionAText">
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'A'}">
                    <span class="option-label">(a)</span><span class="option-text">{{ card.optionAText }}</span>
                  </div>
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'B'}" *ngIf="card.optionBText">
                    <span class="option-label">(b)</span><span class="option-text">{{ card.optionBText }}</span>
                  </div>
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'C'}" *ngIf="card.optionCText">
                    <span class="option-label">(c)</span><span class="option-text">{{ card.optionCText }}</span>
                  </div>
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'D'}" *ngIf="card.optionDText">
                    <span class="option-label">(d)</span><span class="option-text">{{ card.optionDText }}</span>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="'lazyLoad'">
        <div *ngIf="isLoadingQuestions" class="loading-indicator">
          <mat-progress-spinner diameter="36" mode="indeterminate" color="primary"></mat-progress-spinner>
          <span>Loading questions...</span>
        </div>
        <!-- Only show error if not loading -->
        <div *ngIf="hasQuestionsError && !isLoadingQuestions" class="error-message">
          <mat-icon>error</mat-icon> {{ questionsErrorMessage }}
        </div>
        <ng-container *ngIf="!isLoadingQuestions && !hasQuestionsError">
          <div class="lazy-load-container">
            <ng-container *ngFor="let card of displayedCards">
              <!-- Bilingual view (2x2 layout) -->
              <mat-card *ngIf="selectedLanguage === 'bilingual'"
                        class="ias-card bilingual-card"
                        [ngClass]="{'collapsed': card.collapsed}"
                        (click)="selectCard(card)">
                <mat-card-header class="card-header" (click)="toggleCard(card); $event.stopPropagation()">
                  <button mat-icon-button>
                    <mat-icon>{{ card.collapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
                  </button>
                </mat-card-header>
                <mat-card-content>
                  <!-- English content (top row) -->
                  <div class="bilingual-row">
                    <!-- English Question Image -->
                    <div class="bilingual-cell" *ngIf="selectedContentType !== 'textOnly'">
                      <div class="image-container">
                        <img [src]="card.imageUrl" alt="English Question Image" class="centered-image">
                      </div>
                    </div>

                    <!-- English Question Text -->
                    <div class="bilingual-cell" *ngIf="selectedContentType !== 'imageOnly'">
                      <div [ngClass]="{'hidden-content': card.collapsed}" class="question-text-container">
                        <p>{{ card.questionText }}</p>
                      </div>
                    </div>
                  </div>
                    <!-- OCR Question Figure -->
                    <div class="question-figure-container" *ngIf="card.questionFigureUrl">
                      <img [src]="card.questionFigureUrl" [alt]="card.questionFigureCaption || 'Question Figure'" class="question-figure-img">
                      <p *ngIf="card.questionFigureCaption" class="figure-caption">{{ card.questionFigureCaption }}</p>
                    </div>

                  <!-- Hindi content (bottom row) -->
                  <div class="bilingual-row">
                    <!-- Hindi Question Image -->
                    <div class="bilingual-cell" *ngIf="selectedContentType !== 'textOnly'">
                      <div class="image-container">
                        <img [src]="card.hindiQuestionImageUrl || card.hindiImageUrl" alt="Hindi Question Image" class="centered-image">
                      </div>
                    </div>

                    <!-- Hindi Question Text -->
                    <div class="bilingual-cell" *ngIf="selectedContentType !== 'imageOnly'">
                      <div [ngClass]="{'hidden-content': card.collapsed}" class="question-text-container">
                        <p>{{ card.hindiQuestionText }}</p>
                      </div>
                    </div>
                  </div>

                    <!-- Hindi Options Grid -->
                    <div class="options-grid" [class.options-vertical]="optionsLayoutVertical" *ngIf="!card.collapsed && selectedContentType !== 'textOnly' && (card.hindiOptionAImageUrl || card.hindiOptionBImageUrl || card.hindiOptionCImageUrl || card.hindiOptionDImageUrl)">
                      <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'A'}" *ngIf="card.hindiOptionAImageUrl">
                        <span class="option-label">(a)</span>
                        <img [src]="card.hindiOptionAImageUrl" alt="Option A Hindi" class="option-img">
                      </div>
                      <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'B'}" *ngIf="card.hindiOptionBImageUrl">
                        <span class="option-label">(b)</span>
                        <img [src]="card.hindiOptionBImageUrl" alt="Option B Hindi" class="option-img">
                      </div>
                      <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'C'}" *ngIf="card.hindiOptionCImageUrl">
                        <span class="option-label">(c)</span>
                        <img [src]="card.hindiOptionCImageUrl" alt="Option C Hindi" class="option-img">
                      </div>
                      <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'D'}" *ngIf="card.hindiOptionDImageUrl">
                        <span class="option-label">(d)</span>
                        <img [src]="card.hindiOptionDImageUrl" alt="Option D Hindi" class="option-img">
                      </div>
                    </div>
                    <!-- OCR Text Options -->
                    <div class="options-grid text-options-grid" [class.options-vertical]="optionsLayoutVertical"
                         *ngIf="!card.collapsed && card.optionAText">
                      <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'A'}">
                        <span class="option-label">(a)</span><span class="option-text">{{ card.optionAText }}</span>
                      </div>
                      <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'B'}" *ngIf="card.optionBText">
                        <span class="option-label">(b)</span><span class="option-text">{{ card.optionBText }}</span>
                      </div>
                      <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'C'}" *ngIf="card.optionCText">
                        <span class="option-label">(c)</span><span class="option-text">{{ card.optionCText }}</span>
                      </div>
                      <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'D'}" *ngIf="card.optionDText">
                        <span class="option-label">(d)</span><span class="option-text">{{ card.optionDText }}</span>
                      </div>
                    </div>
                </mat-card-content>
              </mat-card>

              <!-- English Only view (1x2 layout) -->
              <mat-card *ngIf="selectedLanguage === 'englishOnly'"
                        class="ias-card"
                        [ngClass]="{'collapsed': card.collapsed}"
                        (click)="selectCard(card)">
                <mat-card-header class="card-header" (click)="toggleCard(card); $event.stopPropagation()">
                  <button mat-icon-button>
                    <mat-icon>{{ card.collapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
                  </button>
                </mat-card-header>
                <mat-card-content>
                  <div class="single-language-row">
                    <!-- English Question Image -->
                    <div class="single-language-cell" *ngIf="selectedContentType !== 'textOnly'">
                      <div class="image-container">
                        <img [src]="card.imageUrl" alt="English Question Image" class="centered-image">
                      </div>
                    </div>

                    <!-- English Question Text -->
                    <div class="single-language-cell" *ngIf="selectedContentType !== 'imageOnly'">
                      <div [ngClass]="{'hidden-content': card.collapsed}" class="question-text-container">
                        <p>{{ card.questionText }}</p>
                      </div>
                    </div>
                  </div>

                    <!-- OCR Question Figure -->
                    <div class="question-figure-container" *ngIf="card.questionFigureUrl">
                      <img [src]="card.questionFigureUrl" [alt]="card.questionFigureCaption || 'Question Figure'" class="question-figure-img">
                      <p *ngIf="card.questionFigureCaption" class="figure-caption">{{ card.questionFigureCaption }}</p>
                    </div>
                    <!-- Options Grid -->
                    <div class="options-grid" [class.options-vertical]="optionsLayoutVertical" *ngIf="!card.collapsed && selectedContentType !== 'textOnly' && (card.optionAImageUrl || card.optionBImageUrl || card.optionCImageUrl || card.optionDImageUrl)">
                      <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'A'}" *ngIf="card.optionAImageUrl">
                        <span class="option-label">(a)</span>
                        <img [src]="card.optionAImageUrl" alt="Option A" class="option-img">
                      </div>
                      <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'B'}" *ngIf="card.optionBImageUrl">
                        <span class="option-label">(b)</span>
                        <img [src]="card.optionBImageUrl" alt="Option B" class="option-img">
                      </div>
                      <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'C'}" *ngIf="card.optionCImageUrl">
                        <span class="option-label">(c)</span>
                        <img [src]="card.optionCImageUrl" alt="Option C" class="option-img">
                      </div>
                      <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'D'}" *ngIf="card.optionDImageUrl">
                        <span class="option-label">(d)</span>
                        <img [src]="card.optionDImageUrl" alt="Option D" class="option-img">
                      </div>
                    </div>
                    <!-- OCR Text Options -->
                    <div class="options-grid text-options-grid" [class.options-vertical]="optionsLayoutVertical"
                         *ngIf="!card.collapsed && card.optionAText">
                      <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'A'}">
                        <span class="option-label">(a)</span><span class="option-text">{{ card.optionAText }}</span>
                      </div>
                      <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'B'}" *ngIf="card.optionBText">
                        <span class="option-label">(b)</span><span class="option-text">{{ card.optionBText }}</span>
                      </div>
                      <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'C'}" *ngIf="card.optionCText">
                        <span class="option-label">(c)</span><span class="option-text">{{ card.optionCText }}</span>
                      </div>
                      <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'D'}" *ngIf="card.optionDText">
                        <span class="option-label">(d)</span><span class="option-text">{{ card.optionDText }}</span>
                      </div>
                    </div>
                </mat-card-content>
              </mat-card>

              <!-- Hindi Only view (1x2 layout) -->
              <mat-card *ngIf="selectedLanguage === 'hindiOnly'"
                        class="ias-card"
                        [ngClass]="{'collapsed': card.collapsed}"
                        (click)="selectCard(card)">
                <mat-card-header class="card-header" (click)="toggleCard(card); $event.stopPropagation()">
                  <button mat-icon-button>
                    <mat-icon>{{ card.collapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
                  </button>
                </mat-card-header>
                <mat-card-content>
                  <div class="single-language-row">
                    <!-- Hindi Question Image -->
                    <div class="single-language-cell" *ngIf="selectedContentType !== 'textOnly'">
                      <div class="image-container">
                        <img [src]="card.hindiQuestionImageUrl || card.hindiImageUrl" alt="Hindi Question Image" class="centered-image">
                      </div>
                    </div>

                    <!-- Hindi Question Text -->
                    <div class="single-language-cell" *ngIf="selectedContentType !== 'imageOnly'">
                      <div [ngClass]="{'hidden-content': card.collapsed}" class="question-text-container">
                        <p>{{ card.hindiQuestionText }}</p>
                      </div>
                    </div>
                  </div>

                    <!-- Hindi Options Grid -->
                    <div class="options-grid" [class.options-vertical]="optionsLayoutVertical" *ngIf="!card.collapsed && selectedContentType !== 'textOnly' && (card.hindiOptionAImageUrl || card.hindiOptionBImageUrl || card.hindiOptionCImageUrl || card.hindiOptionDImageUrl)">
                      <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'A'}" *ngIf="card.hindiOptionAImageUrl">
                        <span class="option-label">(a)</span>
                        <img [src]="card.hindiOptionAImageUrl" alt="Option A Hindi" class="option-img">
                      </div>
                      <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'B'}" *ngIf="card.hindiOptionBImageUrl">
                        <span class="option-label">(b)</span>
                        <img [src]="card.hindiOptionBImageUrl" alt="Option B Hindi" class="option-img">
                      </div>
                      <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'C'}" *ngIf="card.hindiOptionCImageUrl">
                        <span class="option-label">(c)</span>
                        <img [src]="card.hindiOptionCImageUrl" alt="Option C Hindi" class="option-img">
                      </div>
                      <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'D'}" *ngIf="card.hindiOptionDImageUrl">
                        <span class="option-label">(d)</span>
                        <img [src]="card.hindiOptionDImageUrl" alt="Option D Hindi" class="option-img">
                      </div>
                    </div>
                    <!-- OCR Text Options -->
                    <div class="options-grid text-options-grid" [class.options-vertical]="optionsLayoutVertical"
                         *ngIf="!card.collapsed && card.optionAText">
                      <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'A'}">
                        <span class="option-label">(a)</span><span class="option-text">{{ card.optionAText }}</span>
                      </div>
                      <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'B'}" *ngIf="card.optionBText">
                        <span class="option-label">(b)</span><span class="option-text">{{ card.optionBText }}</span>
                      </div>
                      <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'C'}" *ngIf="card.optionCText">
                        <span class="option-label">(c)</span><span class="option-text">{{ card.optionCText }}</span>
                      </div>
                      <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'D'}" *ngIf="card.optionDText">
                        <span class="option-label">(d)</span><span class="option-text">{{ card.optionDText }}</span>
                      </div>
                    </div>
                </mat-card-content>
              </mat-card>
            </ng-container>

            <!-- Lazy loading indicator at the bottom -->
            <div *ngIf="isLoadingMoreLazy" class="loading-indicator lazy-loading-indicator">
              <mat-progress-spinner diameter="36" mode="indeterminate" color="primary"></mat-progress-spinner>
              <span>Loading more questions...</span>
            </div>

            <!-- End of content message -->
            <div *ngIf="lazyLoadedCount >= allCards.length && allCards.length > 0" class="end-of-content">
              <mat-icon>check_circle</mat-icon> All questions loaded ({{ allCards.length }} total)
            </div>

            <!-- Scroll helper message -->
            <div *ngIf="lazyLoadedCount < allCards.length && !isLoadingMoreLazy" class="scroll-helper">
              <mat-icon>arrow_downward</mat-icon> Scroll down to load more questions
              <button mat-raised-button color="primary" class="load-more-button" (click)="loadMoreLazy()">
                Load More Questions
              </button>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="'paginated10'">
        <div *ngIf="isLoadingQuestions" class="loading-indicator">
          <mat-progress-spinner diameter="36" mode="indeterminate" color="primary"></mat-progress-spinner>
          <span>Loading questions...</span>
        </div>
        <!-- Only show error if not loading -->
        <div *ngIf="hasQuestionsError && !isLoadingQuestions" class="error-message">
          <mat-icon>error</mat-icon> {{ questionsErrorMessage }}
        </div>
        <ng-container *ngIf="!isLoadingQuestions && !hasQuestionsError">
          <ng-container *ngFor="let card of displayedCards">
            <!-- Bilingual view (2x2 layout) -->
            <mat-card *ngIf="selectedLanguage === 'bilingual'"
                      class="ias-card bilingual-card"
                      [ngClass]="{'collapsed': card.collapsed}"
                      (click)="selectCard(card)">
              <mat-card-header class="card-header">
                <button mat-icon-button (click)="toggleCard(card); $event.stopPropagation()">
                  <mat-icon>{{ card.collapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
                </button>
              </mat-card-header>
              <mat-card-content>
                <!-- English content (top row) -->
                <div class="bilingual-row">
                  <!-- English Question Image -->
                  <div class="bilingual-cell" *ngIf="selectedContentType !== 'textOnly'">
                    <div class="image-container">
                      <img [src]="card.imageUrl" alt="English Question Image" class="centered-image">
                    </div>
                  </div>

                  <!-- English Question Text -->
                  <div class="bilingual-cell" *ngIf="selectedContentType !== 'imageOnly'">
                    <div [ngClass]="{'hidden-content': card.collapsed}" class="question-text-container">
                      <p>{{ card.questionText }}</p>
                    </div>
                  </div>
                </div>
                <!-- OCR Question Figure -->
                <div class="question-figure-container" *ngIf="card.questionFigureUrl">
                  <img [src]="card.questionFigureUrl" [alt]="card.questionFigureCaption || 'Question Figure'" class="question-figure-img">
                  <p *ngIf="card.questionFigureCaption" class="figure-caption">{{ card.questionFigureCaption }}</p>
                </div>

                <!-- Hindi content (bottom row) -->
                <div class="bilingual-row">
                  <!-- Hindi Question Image -->
                  <div class="bilingual-cell" *ngIf="selectedContentType !== 'textOnly'">
                    <div class="image-container">
                      <img [src]="card.hindiQuestionImageUrl || card.hindiImageUrl" alt="Hindi Question Image" class="centered-image">
                    </div>
                  </div>

                  <!-- Hindi Question Text -->
                  <div class="bilingual-cell" *ngIf="selectedContentType !== 'imageOnly'">
                    <div [ngClass]="{'hidden-content': card.collapsed}" class="question-text-container">
                      <p>{{ card.hindiQuestionText }}</p>
                    </div>
                  </div>
                </div>

                <!-- Hindi Options Grid -->
                <div class="options-grid" [class.options-vertical]="optionsLayoutVertical" *ngIf="!card.collapsed && selectedContentType !== 'textOnly' && (card.hindiOptionAImageUrl || card.hindiOptionBImageUrl || card.hindiOptionCImageUrl || card.hindiOptionDImageUrl)">
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'A'}" *ngIf="card.hindiOptionAImageUrl">
                    <span class="option-label">(a)</span>
                    <img [src]="card.hindiOptionAImageUrl" alt="Option A Hindi" class="option-img">
                  </div>
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'B'}" *ngIf="card.hindiOptionBImageUrl">
                    <span class="option-label">(b)</span>
                    <img [src]="card.hindiOptionBImageUrl" alt="Option B Hindi" class="option-img">
                  </div>
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'C'}" *ngIf="card.hindiOptionCImageUrl">
                    <span class="option-label">(c)</span>
                    <img [src]="card.hindiOptionCImageUrl" alt="Option C Hindi" class="option-img">
                  </div>
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'D'}" *ngIf="card.hindiOptionDImageUrl">
                    <span class="option-label">(d)</span>
                    <img [src]="card.hindiOptionDImageUrl" alt="Option D Hindi" class="option-img">
                  </div>
                </div>
                <!-- OCR Text Options -->
                <div class="options-grid text-options-grid" [class.options-vertical]="optionsLayoutVertical"
                     *ngIf="!card.collapsed && card.optionAText">
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'A'}">
                    <span class="option-label">(a)</span><span class="option-text">{{ card.optionAText }}</span>
                  </div>
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'B'}" *ngIf="card.optionBText">
                    <span class="option-label">(b)</span><span class="option-text">{{ card.optionBText }}</span>
                  </div>
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'C'}" *ngIf="card.optionCText">
                    <span class="option-label">(c)</span><span class="option-text">{{ card.optionCText }}</span>
                  </div>
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'D'}" *ngIf="card.optionDText">
                    <span class="option-label">(d)</span><span class="option-text">{{ card.optionDText }}</span>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <!-- English Only view (1x2 layout) -->
            <mat-card *ngIf="selectedLanguage === 'englishOnly'"
                      class="ias-card"
                      [ngClass]="{'collapsed': card.collapsed}"
                      (click)="selectCard(card)">
              <mat-card-header class="card-header">
                <button mat-icon-button (click)="toggleCard(card); $event.stopPropagation()">
                  <mat-icon>{{ card.collapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
                </button>
              </mat-card-header>
              <mat-card-content>
                <div class="single-language-row">
                  <!-- English Question Image -->
                  <div class="single-language-cell" *ngIf="selectedContentType !== 'textOnly'">
                    <div class="image-container">
                      <img [src]="card.imageUrl" alt="English Question Image" class="centered-image">
                    </div>
                  </div>

                  <!-- English Question Text -->
                  <div class="single-language-cell" *ngIf="selectedContentType !== 'imageOnly'">
                    <div [ngClass]="{'hidden-content': card.collapsed}" class="question-text-container">
                      <p>{{ card.questionText }}</p>
                    </div>
                  </div>
                </div>

                <!-- OCR Question Figure -->
                <div class="question-figure-container" *ngIf="card.questionFigureUrl">
                  <img [src]="card.questionFigureUrl" [alt]="card.questionFigureCaption || 'Question Figure'" class="question-figure-img">
                  <p *ngIf="card.questionFigureCaption" class="figure-caption">{{ card.questionFigureCaption }}</p>
                </div>
                <!-- Options Grid -->
                <div class="options-grid" [class.options-vertical]="optionsLayoutVertical" *ngIf="!card.collapsed && selectedContentType !== 'textOnly' && (card.optionAImageUrl || card.optionBImageUrl || card.optionCImageUrl || card.optionDImageUrl)">
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'A'}" *ngIf="card.optionAImageUrl">
                    <span class="option-label">(a)</span>
                    <img [src]="card.optionAImageUrl" alt="Option A" class="option-img">
                  </div>
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'B'}" *ngIf="card.optionBImageUrl">
                    <span class="option-label">(b)</span>
                    <img [src]="card.optionBImageUrl" alt="Option B" class="option-img">
                  </div>
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'C'}" *ngIf="card.optionCImageUrl">
                    <span class="option-label">(c)</span>
                    <img [src]="card.optionCImageUrl" alt="Option C" class="option-img">
                  </div>
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'D'}" *ngIf="card.optionDImageUrl">
                    <span class="option-label">(d)</span>
                    <img [src]="card.optionDImageUrl" alt="Option D" class="option-img">
                  </div>
                </div>
                <!-- OCR Text Options -->
                <div class="options-grid text-options-grid" [class.options-vertical]="optionsLayoutVertical"
                     *ngIf="!card.collapsed && card.optionAText">
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'A'}">
                    <span class="option-label">(a)</span><span class="option-text">{{ card.optionAText }}</span>
                  </div>
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'B'}" *ngIf="card.optionBText">
                    <span class="option-label">(b)</span><span class="option-text">{{ card.optionBText }}</span>
                  </div>
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'C'}" *ngIf="card.optionCText">
                    <span class="option-label">(c)</span><span class="option-text">{{ card.optionCText }}</span>
                  </div>
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'D'}" *ngIf="card.optionDText">
                    <span class="option-label">(d)</span><span class="option-text">{{ card.optionDText }}</span>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <!-- Hindi Only view (1x2 layout) -->
            <mat-card *ngIf="selectedLanguage === 'hindiOnly'"
                      class="ias-card"
                      [ngClass]="{'collapsed': card.collapsed}"
                      (click)="selectCard(card)">
              <mat-card-header class="card-header">
                <button mat-icon-button (click)="toggleCard(card); $event.stopPropagation()">
                  <mat-icon>{{ card.collapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
                </button>
              </mat-card-header>
              <mat-card-content>
                <div class="single-language-row">
                  <!-- Hindi Question Image -->
                  <div class="single-language-cell" *ngIf="selectedContentType !== 'textOnly'">
                    <div class="image-container">
                      <img [src]="card.hindiQuestionImageUrl || card.hindiImageUrl" alt="Hindi Question Image" class="centered-image">
                    </div>
                  </div>

                  <!-- Hindi Question Text -->
                  <div class="single-language-cell" *ngIf="selectedContentType !== 'imageOnly'">
                    <div [ngClass]="{'hidden-content': card.collapsed}" class="question-text-container">
                      <p>{{ card.hindiQuestionText }}</p>
                    </div>
                  </div>
                </div>

                <!-- Hindi Options Grid -->
                <div class="options-grid" [class.options-vertical]="optionsLayoutVertical" *ngIf="!card.collapsed && selectedContentType !== 'textOnly' && (card.hindiOptionAImageUrl || card.hindiOptionBImageUrl || card.hindiOptionCImageUrl || card.hindiOptionDImageUrl)">
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'A'}" *ngIf="card.hindiOptionAImageUrl">
                    <span class="option-label">(a)</span>
                    <img [src]="card.hindiOptionAImageUrl" alt="Option A Hindi" class="option-img">
                  </div>
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'B'}" *ngIf="card.hindiOptionBImageUrl">
                    <span class="option-label">(b)</span>
                    <img [src]="card.hindiOptionBImageUrl" alt="Option B Hindi" class="option-img">
                  </div>
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'C'}" *ngIf="card.hindiOptionCImageUrl">
                    <span class="option-label">(c)</span>
                    <img [src]="card.hindiOptionCImageUrl" alt="Option C Hindi" class="option-img">
                  </div>
                  <div class="option-box" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'D'}" *ngIf="card.hindiOptionDImageUrl">
                    <span class="option-label">(d)</span>
                    <img [src]="card.hindiOptionDImageUrl" alt="Option D Hindi" class="option-img">
                  </div>
                </div>
                <!-- OCR Text Options -->
                <div class="options-grid text-options-grid" [class.options-vertical]="optionsLayoutVertical"
                     *ngIf="!card.collapsed && card.optionAText">
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'A'}">
                    <span class="option-label">(a)</span><span class="option-text">{{ card.optionAText }}</span>
                  </div>
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'B'}" *ngIf="card.optionBText">
                    <span class="option-label">(b)</span><span class="option-text">{{ card.optionBText }}</span>
                  </div>
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'C'}" *ngIf="card.optionCText">
                    <span class="option-label">(c)</span><span class="option-text">{{ card.optionCText }}</span>
                  </div>
                  <div class="option-box text-option" [ngClass]="{'correct-answer': showCorrectAnswer && getCorrectAnswerLetter(card) === 'D'}" *ngIf="card.optionDText">
                    <span class="option-label">(d)</span><span class="option-text">{{ card.optionDText }}</span>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </ng-container>
        </ng-container>
      </ng-container>

      <!-- 4) SINGLE-QUESTION VIEW -->
      <ng-container *ngSwitchCase="'single'">
        <div *ngIf="isLoadingQuestions" class="loading-indicator">
          <mat-progress-spinner diameter="36" mode="indeterminate" color="primary"></mat-progress-spinner>
          <span>Loading questions...</span>
        </div>
        <!-- Only show error if not loading -->
        <div *ngIf="hasQuestionsError && !isLoadingQuestions" class="error-message">
          <mat-icon>error</mat-icon> {{ questionsErrorMessage }}
        </div>

        <!-- Bilingual view (2x2 layout) -->
        <div *ngIf="displayedCards.length > 0 && !isLoadingQuestions && !hasQuestionsError && selectedLanguage === 'bilingual'"
             class="single-question-view bilingual-view"
             (click)="selectCard(displayedCards[0])">
          <h3>Question {{ currentSingleIndex + 1 }} of {{ allCards.length }}</h3>

          <!-- English content (top row) -->
          <div class="bilingual-row">
            <!-- English Question Image -->
            <div class="bilingual-cell" *ngIf="selectedContentType !== 'textOnly'">
              <div class="image-container">
                <img [src]="displayedCards[0].imageUrl" alt="English Question Image" class="question-image">
              </div>
            </div>

            <!-- English Question Text -->
            <div class="bilingual-cell" *ngIf="selectedContentType !== 'imageOnly'">
              <div class="question-text-container">
                <p [innerHTML]="displayedCards[0].questionText || 'No question text available'"></p>
              </div>
            </div>
          </div>

          <!-- Hindi content (bottom row) -->
          <div class="bilingual-row">
            <!-- Hindi Question Image -->
            <div class="bilingual-cell" *ngIf="selectedContentType !== 'textOnly'">
              <div class="image-container">
                <img [src]="displayedCards[0].hindiQuestionImageUrl || displayedCards[0].hindiImageUrl" alt="Hindi Question Image" class="question-image">
              </div>
            </div>

            <!-- Hindi Question Text -->
            <div class="bilingual-cell" *ngIf="selectedContentType !== 'imageOnly'">
              <div class="question-text-container">
                <p [innerHTML]="displayedCards[0].hindiQuestionText || 'No Hindi question text available'"></p>
              </div>
            </div>
          </div>
        </div>

        <!-- English only view -->
        <div *ngIf="displayedCards.length > 0 && !isLoadingQuestions && !hasQuestionsError && selectedLanguage === 'englishOnly'"
             class="single-question-view"
             (click)="selectCard(displayedCards[0])">
          <div class="image-portion" *ngIf="selectedContentType !== 'textOnly'">
            <img [src]="displayedCards[0].imageUrl" alt="English Question Image" class="question-image"/>
          </div>
          <div class="text-portion" *ngIf="selectedContentType !== 'imageOnly'">
            <h3>Question {{ currentSingleIndex + 1 }} of {{ allCards.length }}</h3>
            <div class="question-text">
              <p [innerHTML]="displayedCards[0].questionText || 'No question text available'"></p>
            </div>
          </div>
        </div>

        <!-- Hindi only view -->
        <div *ngIf="displayedCards.length > 0 && !isLoadingQuestions && !hasQuestionsError && selectedLanguage === 'hindiOnly'"
             class="single-question-view"
             (click)="selectCard(displayedCards[0])">
          <div class="image-portion" *ngIf="selectedContentType !== 'textOnly'">
            <img [src]="displayedCards[0].hindiQuestionImageUrl || displayedCards[0].hindiImageUrl" alt="Hindi Question Image" class="question-image"/>
          </div>
          <div class="text-portion" *ngIf="selectedContentType !== 'imageOnly'">
            <h3>Question {{ currentSingleIndex + 1 }} of {{ allCards.length }}</h3>
            <div class="question-text">
              <p [innerHTML]="displayedCards[0].hindiQuestionText || 'No Hindi question text available'"></p>
            </div>
          </div>
        </div>
      </ng-container>

    </ng-container>

  </div>
  <!-- Pane 3 footer → pagination for 10/page & single -->
  <!-- If NOT in 10-page or single mode, just show normal footer -->
  <ng-container *ngIf="displayMode === 'paginated10' || displayMode === 'single'; else normalP3Footer">
    <mat-toolbar class="pane-footer" style="justify-content: center;">
      <!-- Modern Angular Material pagination -->
      <div class="modern-pagination">
        <button mat-icon-button color="primary"
                (click)="goToPreviousPage()"
                [disabled]="(displayMode === 'paginated10' && currentPage <= 1) ||
                                (displayMode === 'single' && currentSingleIndex <= 0)">
          <mat-icon>navigate_before</mat-icon>
        </button>

        <div class="page-input-container">
          <div class="page-display" (click)="openPageDialog()">
            <span>{{ displayMode === 'single' ? currentSingleIndex + 1 : currentPage }}</span>
            <span class="page-count-separator">of</span>
            <span>{{ displayMode === 'single' ? allCards.length : totalPages }}</span>
          </div>
        </div>

        <button mat-icon-button color="primary"
                (click)="goToNextPage()"
                [disabled]="(displayMode === 'paginated10' && currentPage >= totalPages) ||
                                (displayMode === 'single' && currentSingleIndex >= allCards.length - 1)">
          <mat-icon>navigate_next</mat-icon>
        </button>
      </div>
    </mat-toolbar>
  </ng-container>
  <ng-template #normalP3Footer>
  </ng-template>
</div>
